import React from 'react';
import orquestacion from '../assets/images/1.jpeg';
import avatar from '../assets/images/2.jpeg';
import avatars from '../assets/images/3.jpeg';

const Technology = () => {
  const techCards = [
    {
      image: orquestacion, // Añade tu imagen aquí
      title: 'Orquestación inteligente',
      description: 'El cerebro detrás de la experiencia. Gestiona, personaliza y optimiza todos los avatares desde un único lugar.',
      items: [
        'Configuración total personalizada',
        'Gestión operativa automatizada',
        'Analítica avanzada en tiempo real',
        'Despliegue multicanal integrado'
      ]
    },
    {
      image: avatar, // Añade tu imagen aquí
      title: 'IA conversacional',
      description: 'Modelos de lenguaje avanzados con arquitectura multi-agente y RAG para respuestas precisas.',
      items: [
        'LLM de última generación',
        'Arquitectura multi-agente',
        'RAG personalizado por sector',
        'Procesamiento en tiempo real'
      ]
    },
    {
      image: avatars, // Añade tu imagen aquí
      title: 'Avatares 3D',
      description: 'Tecnología Three.js con animación facial y renderizado de alta calidad.',
      items: [
        'Three.js rendering avanzado',
        'Animación facial sincronizada',
        'WebSocket comunicación real-time',
        'APIs abiertas e integrables'
      ]
    }
  ];

  return (
    <section className="section tech-section" id="tecnologia">
      <div className="section-header">
        <div className="section-tag">Tecnología</div>
        <h2 className="section-title">Plataforma de vanguardia</h2>
        <p className="section-subtitle">
          Tecnología propia desarrollada con los estándares más altos de la industria.
        </p>
      </div>
      <div className="grid-3">
        {techCards.map((card, index) => (
          <div key={index} className="tech-card">
            <span className="tech-card-image">
              <img src={card.image} alt={card.title} />
            </span>
            <h3 className="tech-title">{card.title}</h3>
            <p className="tech-description">{card.description}</p>
            <ul className="tech-list">
              {card.items.map((item, idx) => (
                <li key={idx}>
                  <span className="tech-list-icon">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Technology;
